import type { RouteRecordRaw } from 'vue-router'
import { ROLE_GROUPS } from '../../constants/roleGroups'

export const adminCommunityRoutes: RouteRecordRaw[] = [
  {
    path: 'cms/posts',
    name: 'admin.cms.posts',
    component: () => import('../../views/cms/CmsPostsView.vue'),
    meta: {
      title: 'CMS - Posts',
      requiresAuth: true,
      requireRoles: ROLE_GROUPS.ADMIN_PANEL,
      requiredPermission: 'admin.cms.view',
    },
  },
  {
    path: 'cms/posts/new',
    name: 'admin.cms.posts.new',
    component: () => import('../../views/cms/CmsPostEditView.vue'),
    meta: {
      title: 'CMS - New Post',
      requiresAuth: true,
      requireRoles: ROLE_GROUPS.ADMIN_PANEL,
      requiredPermission: 'admin.cms.manage',
    },
  },
  {
    path: 'cms/posts/:id/edit',
    name: 'admin.cms.posts.edit',
    component: () => import('../../views/cms/CmsPostEditView.vue'),
    meta: {
      title: 'CMS - Edit Post',
      requiresAuth: true,
      requireRoles: ROLE_GROUPS.ADMIN_PANEL,
      requiredPermission: 'admin.cms.manage',
    },
  },
  {
    path: 'cms/forum',
    name: 'admin.cms.forum',
    component: () => import('../../views/cms/CmsForumView.vue'),
    meta: {
      title: 'CMS - Forum',
      requiresAuth: true,
      requireRoles: ROLE_GROUPS.ADMIN_PANEL,
      requiredPermission: 'admin.cms.view',
    },
  },
  {
    path: 'cms/tags',
    name: 'admin.cms.tags',
    component: () => import('../../views/cms/CmsTagsView.vue'),
    meta: {
      title: 'CMS - Tags',
      requiresAuth: true,
      requireRoles: ROLE_GROUPS.ADMIN_PANEL,
      requiredPermission: 'admin.cms.view',
    },
  },
  {
    path: 'cms/settings',
    name: 'admin.cms.settings',
    component: () => import('../../views/cms/CmsSettingsView.vue'),
    meta: {
      title: 'CMS - Settings',
      requiresAuth: true,
      requireRoles: ROLE_GROUPS.ADMIN_PANEL,
      requiredPermission: 'admin.cms.view',
    },
  },
  // Legacy aliases
  { path: 'community/blog', redirect: { name: 'admin.cms.posts' } },
  { path: 'community/forums', redirect: { name: 'admin.cms.forum' } },
  { path: 'community/blog/tags', redirect: { name: 'admin.cms.tags' } },
  { path: 'community/blog/categories', redirect: { name: 'admin.cms.settings' } },
]

